import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";

const updateLinkSx = {
  mr: "34px",
  color: "#006699",
  cursor: "pointer",
  textDecoration: "underline",
  width: "fit-content",
};

// "Address is correct" and "contact person is correct" checkboxes, each with a link to update the details
const ConfirmationCheckboxes = ({ formData, handleCheckboxChange, setAddressDialogOpen, setContactDialogOpen }) => (
  <>
    <Grid item xs={12}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.confirmAddress}
              onChange={handleCheckboxChange("confirmAddress")}
            />
          }
          label="אני מאשר/ת כי מיקום המכשיר הינו כמפורט לעיל."
        />
        <Typography
          variant="body2"
          onClick={() => setAddressDialogOpen(true)}
          sx={updateLinkSx}
        >
          אם הכתובת שגויה, לחצו כאן לעדכון
        </Typography>
      </Box>
    </Grid>
    <Grid item xs={12}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.confirmContactPerson}
              onChange={handleCheckboxChange("confirmContactPerson")}
            />
          }
          label="אני מאשר/ת כי איש הקשר הרלוונטי לצורך הטיפול בקריאה הינו כמפורט לעיל."
        />
        <Typography
          variant="body2"
          onClick={() => setContactDialogOpen(true)}
          sx={updateLinkSx}
        >
          אם הפרטים שגויים, לחצו כאן לעדכון
        </Typography>
      </Box>
    </Grid>
  </>
);

export default ConfirmationCheckboxes;
